import { useQuery, UseQueryOptions } from "@tanstack/react-query"
import { getDarReport, getEmpolyeeFilter } from "./DarRepo"

export const useGetEmpolyeeFilter = ({param={},enable}:{param:any,enable:boolean})=>{
    return useQuery({
        queryKey:['GET_EMPOLYEE_FILTER',param],
        queryFn:()=>getEmpolyeeFilter(param),
        enabled:enable,
        retry:false
    })
}

export const useGetDarReport=({param={},enable}:{param:any,enable:boolean})=>{
    return useQuery({
        queryKey:['GET_DAR_REPORT',param],
        queryFn:()=>getDarReport(param),
        enabled:enable,
        retry:false,
    })
}
